"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2699],{

/***/ 51110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66697);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68866);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70079);
/* harmony import */ var _Info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13614);








function ApyInfo(_param) {
    var netApy = _param.netApy, grossApy = _param.grossApy, flexProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "netApy",
        "grossApy"
    ]);
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslations */ .T_)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        gap: 4,
        flexDir: "column",
        px: {
            base: 0,
            desktop: 8
        },
        py: {
            base: 0,
            desktop: 4
        },
        minW: {
            base: "full",
            desktop: "407px"
        }
    }, flexProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Info__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: t("Net APY"),
                value: netApy
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Info__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: t("Gross APY"),
                value: grossApy
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Info__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: t("Management Fees"),
                value: "10%",
                convertedValue: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
                    flexDir: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                            children: "Treasury 50%"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                            children: "Reservoir 50%"
                        })
                    ]
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (ApyInfo);


/***/ }),

/***/ 47065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _ApyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51110);
/* harmony import */ var _ModalOrDrawer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64881);






var StakingInfoDrawer = function(_param) {
    var close = _param.close, isOpen = _param.isOpen, apyInfoProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "close",
        "isOpen"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_2__/* .ModalOrDrawer */ .NH, {
        placement: "bottom",
        size: "lg",
        scrollBehavior: "inside",
        isOpen: isOpen,
        onClose: function() {
            return close();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_2__/* .ModalOrDrawerOverlay */ .Dx, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_2__/* .ModalOrDragDrawerContent */ .Zt, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_2__/* .ModalOrDrawerHeader */ .BB, {
                        children: "Real Staking APY info"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_2__/* .ModalOrDrawerBody */ .M1, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ApyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, apyInfoProps), {
                            mb: "150px"
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StakingInfoDrawer);


/***/ }),

/***/ 10952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ StakeView; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+media-query@3.2.7_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(86434);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+button@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(31327);
// EXTERNAL MODULE: ./src/components/ApyInfo.tsx
var ApyInfo = __webpack_require__(51110);
// EXTERNAL MODULE: ./src/components/Balance/index.ts
var Balance = __webpack_require__(64345);
// EXTERNAL MODULE: ./src/components/Info/index.ts
var Info = __webpack_require__(13614);
// EXTERNAL MODULE: ./src/components/InputCard/index.ts
var InputCard = __webpack_require__(22806);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(25966);
// EXTERNAL MODULE: ./src/hooks/useApr.ts
var useApr = __webpack_require__(33491);
// EXTERNAL MODULE: ./src/hooks/useCoinUsdValue.ts
var useCoinUsdValue = __webpack_require__(33646);
// EXTERNAL MODULE: ./src/utils/apyToApyList.ts
var apyToApyList = __webpack_require__(3747);
// EXTERNAL MODULE: ./src/utils/bigNumberToNumber.ts
var bigNumberToNumber = __webpack_require__(19089);
// EXTERNAL MODULE: ../node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/format/index.js + 34 modules
var esm_format = __webpack_require__(77180);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
;// CONCATENATED MODULE: ./src/views/Stake/useRewardChartData.tsx






var useRewardChartData = function(amount) {
    var ref = (0,useApr/* useApy */.K8)(), apy = ref.data;
    var ref1 = (0,useCoinUsdValue/* useOneCoinUsdPrice */.D)(), usdPrice = ref1.data;
    var apyList = (0,react.useMemo)(function() {
        return (0,apyToApyList/* default */.Z)(apy);
    }, [
        apy
    ]);
    var rewards = apyList.map(function(apy) {
        return apy * amount;
    });
    var now = new Date();
    var dates = [
        1,
        6,
        12,
        24
    ].map(function(months) {
        return addMonths(now, months);
    }).map(function(date) {
        return (0,esm_format/* default */.Z)(date, "yyyy - MM - dd");
    });
    var usdRewards = usdPrice ? rewards.map(function(reward) {
        return reward * (0,bigNumberToNumber/* default */.Z)(usdPrice);
    }) : Array.from({
        length: 4
    }).map(function(_) {
        return 0;
    });
    return apyList.map(function(apy, i) {
        return {
            apy: apy,
            reward: rewards[i],
            date: dates[i],
            usdReward: usdRewards[i]
        };
    });
};
var addMonths = function(date, months) {
    var copyDate = new Date(date);
    copyDate.setMonth(date.getMonth() + months);
    return copyDate;
};
/* harmony default export */ var Stake_useRewardChartData = (useRewardChartData);

// EXTERNAL MODULE: ../packages/chakra/dist/esm/index.js + 27 modules
var esm = __webpack_require__(52746);
// EXTERNAL MODULE: ./src/components/DynamicHighchartsReact/index.tsx
var DynamicHighchartsReact = __webpack_require__(89372);
;// CONCATENATED MODULE: ./src/components/MonthlyRewardChart.tsx












var MonthlyRewardChart = function(_param) {
    var coinMode = _param.coinMode, amount = _param.amount, _defaultPointIndex = _param.defaultPointIndex, defaultPointIndex = _defaultPointIndex === void 0 ? 2 : _defaultPointIndex, warningMessage = _param.warningMessage, errorMessage = _param.errorMessage, smallChart = _param.smallChart, props = (0,_object_without_properties/* default */.Z)(_param, [
        "coinMode",
        "amount",
        "defaultPointIndex",
        "warningMessage",
        "errorMessage",
        "smallChart"
    ]);
    var ref = (0,react.useState)(defaultPointIndex), pointIndex = ref[0], setPointIndex = ref[1];
    var ref1 = (0,react.useState)(0), tooltipX = ref1[0], setTooltipX = ref1[1];
    var ref2 = (0,react.useState)(0), tooltipY = ref2[0], setTooltipY = ref2[1];
    var ref3 = (0,react.useState)(false), chartActive = ref3[0], setChartActive = ref3[1];
    var data = Stake_useRewardChartData(amount);
    var chartRef = (0,react.useRef)(null);
    var chartData = data.map(function(data) {
        return data.reward;
    });
    var isEmptyData = Boolean(errorMessage || warningMessage) || isEmpty(chartData);
    var chartOptions = useChartOptions({
        data: chartData,
        pointIndex: pointIndex,
        isEmptyData: isEmptyData,
        enablePlotLine: !isEmptyData,
        smallChart: smallChart,
        chartRef: chartRef,
        onPointIndexChanged: setPointIndex,
        onTooltipPositionChanged: function(param) {
            var x = param.x, y = param.y;
            setTooltipX(x);
            setTooltipY(y);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            position: "relative",
            mx: 0,
            sx: {
                /**
           * disallow scrolling
           */ touchAction: "none",
                /**
           * don't truncate xAxis's labels
           */ ".highcharts-axis-labels > span": {
                    minW: "70px!important"
                },
                ".highcharts-axis-labels > span:first-of-type": {
                    left: "10px!important"
                },
                ".highcharts-axis-labels > span:nth-of-type(2)": {
                    transform: "translateX(10px)!important"
                }
            },
            onContextMenu: function(e) {
                // avoid showing context menu
                e.preventDefault();
                return false;
            },
            isActive: !isEmptyData && chartActive && pointIndex >= 0,
            onTouchStartCapture: function() {
                return setChartActive(true);
            },
            onMouseDownCapture: function() {
                return setChartActive(true);
            },
            onTouchEnd: function() {
                return setChartActive(false);
            },
            onMouseEnter: function() {
                return setChartActive(true);
            },
            onMouseLeave: function() {
                return setChartActive(false);
            }
        }, props), {
            children: [
                isEmptyData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "1",
                    justify: "center",
                    pt: "50px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        textStyle: "caption",
                        color: errorMessage ? "error" : "warning",
                        children: errorMessage || warningMessage || "Empty"
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                    hidden: isEmptyData,
                    position: "absolute",
                    top: "".concat(tooltipY, "px"),
                    left: "".concat(tooltipX, "px"),
                    textStyle: "caption",
                    zIndex: "1",
                    children: tooltipFormatter(coinMode, data[pointIndex])
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHighchartsReact/* DynamicHighchartsReact */.e, {
                    options: chartOptions
                })
            ]
        }))
    });
};
var useChartOptions = function(param) {
    var data = param.data, pointIndex = param.pointIndex, onPointIndexChanged = param.onPointIndexChanged, onTooltipPositionChanged = param.onTooltipPositionChanged, smallChart = param.smallChart, isEmptyData = param.isEmptyData, _enablePlotLine = param.enablePlotLine, enablePlotLine = _enablePlotLine === void 0 ? true : _enablePlotLine, chartRef = param.chartRef;
    var t = (0,i18n/* useTranslations */.T_)();
    (0,react.useEffect)(function() {
        var ref;
        var point = ((ref = chartRef.current) === null || ref === void 0 ? void 0 : ref.series[0].points[pointIndex]) || null;
        if (!point) {
            return;
        }
        if (!enablePlotLine) {
            /**
       * hide plotLine and maker when no data
       */ updatePlotLine(point, "transparent");
            point.select(false, false);
        } else {
            var // make sure tooltip has correct initial position
            ref1, ref2;
            /**
       * create a plotLine to replace crosshair, then we can
       * keep this plotLine always visible
       */ updatePlotLine(point);
            /**
       * by selecting the point programmatically and customize
       * its `marker`'s styles in selected state, then we can keep
       * its `marker` always visible
       */ point.select(true, false);
            (ref1 = chartRef.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tooltip) === null || ref2 === void 0 ? void 0 : ref2.refresh(point);
        }
    }, [
        chartRef,
        enablePlotLine,
        pointIndex
    ]);
    var options = {
        responsive: {
            rules: [
                {
                    condition: {
                        callback: function() {
                            return !smallChart && window.innerWidth >= 768;
                        }
                    },
                    chartOptions: {
                        chart: {
                            height: 192
                        }
                    }
                }, 
            ]
        },
        chart: {
            height: 140,
            animation: false,
            backgroundColor: "transparent",
            events: {
                load: function load() {
                    chartRef.current = this;
                }
            },
            spacing: [
                18,
                6,
                16,
                6
            ]
        },
        legend: {
            enabled: false
        },
        title: {
            text: ""
        },
        credits: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
        plotOptions: {
            areaspline: {
                color: {
                    // equals: linear-gradient(151.63deg, #FF96DF 31%, rgba(102, 211, 255, 0) 96%);
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 1,
                        y2: 1
                    },
                    stops: [
                        [
                            0.5,
                            "#FF96DF"
                        ],
                        [
                            0.96,
                            "rgba(102, 211, 255, 0)"
                        ], 
                    ]
                },
                lineColor: "rgba(0,0,0,0)",
                threshold: null,
                lineWidth: 1,
                marker: {
                    lineColor: "transparent",
                    fillColor: "transparent",
                    states: {
                        select: {
                            lineColor: esm/* colors.bg.main */.O9.bg.main,
                            fillColor: "#FF96DF",
                            lineWidth: 2,
                            radius: 6
                        }
                    }
                }
            },
            series: {
                pointPlacement: "on",
                point: {
                    events: {
                        mouseOver: function mouseOver() {
                            onPointIndexChanged(this.index);
                        }
                    }
                }
            }
        },
        tooltip: {
            enabled: true,
            backgroundColor: "transparent",
            borderColor: "transparent",
            shadow: false,
            useHTML: true,
            padding: 0,
            style: {
                color: "transparent",
                pointerEvents: "none"
            },
            positioner: function positioner(labelWidth, labelHeight, point) {
                var paddingX = 5;
                var pointX = this.chart.plotLeft + point.plotX;
                var position = {
                    x: pointX - labelWidth < 0 ? pointX + paddingX : pointX - 100 - paddingX,
                    y: 10
                };
                onTooltipPositionChanged(position);
                return position;
            }
        },
        yAxis: {
            visible: false,
            // fit the max and min tick to the available/full height
            endOnTick: false,
            startOnTick: false,
            min: isEmptyData ? 0 : data[0],
            max: isEmptyData ? 0.1 : data[data.length - 1]
        },
        xAxis: {
            categories: [
                t("{num} Months", {
                    num: 1
                }),
                t("{num} Months", {
                    num: 6
                }),
                t("{num} Months", {
                    num: 12
                }),
                t("{num} Months", {
                    num: 24
                }), 
            ],
            lineWidth: 2,
            minPadding: 0,
            tickmarkPlacement: "on",
            labels: {
                autoRotation: [
                    0
                ],
                padding: 0,
                style: (0,_object_spread/* default */.Z)({
                    color: esm/* colors.text.light */.O9.text.light
                }, esm/* textStyles.caption */.sq.caption),
                useHTML: true
            }
        },
        series: [
            {
                type: "areaspline",
                data: isEmptyData ? data.map(function() {
                    return 0;
                }) : data
            }, 
        ]
    };
    return options;
};
var updatePlotLine = function(point) {
    var lineColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : esm/* colors.pink.500 */.O9.pink[500];
    var ref;
    var chart = point.series.chart;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (((ref = chart.xAxis[0].plotLinesAndBands) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        chart.xAxis[0].update({
            plotLines: [
                {
                    id: "xPlotLine",
                    value: point.x,
                    width: 1,
                    color: lineColor
                }, 
            ]
        });
    } else {
        chart.xAxis[0].addPlotLine({
            id: "xPlotLine",
            value: point.x,
            width: 1,
            color: lineColor
        });
    }
};
function isEmpty(data) {
    return !data || data.every(function(v) {
        return v <= 0;
    });
}
function tooltipFormatter(coinMode, dataPoint) {
    var reward = dataPoint.reward;
    var displayDecimals = 2;
    var formattedValue = (0,format/* formatNumber */.uf)(reward || 0, displayDecimals);
    var formattedUsd = (0,format/* formatNumber */.uf)(dataPoint.usdReward, displayDecimals);
    if (Number(formattedValue) === 0 && reward !== 0) {
        var index = String(reward).search(/[1-9]/);
        formattedValue = String(reward).slice(0, index + displayDecimals);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        rounded: "5px",
        flexDir: "column",
        alignItems: "flex-end",
        minW: "100px",
        boxShadow: "card.normal",
        bg: "bg.main",
        p: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mb: 2,
                children: dataPoint.date
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                children: [
                    formattedValue,
                    " ",
                    useCoinMode/* COIN_MODE */.rm[coinMode].name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                color: "text.light",
                children: [
                    formattedUsd,
                    " USD"
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/StakingInfoDrawer.tsx
var StakingInfoDrawer = __webpack_require__(47065);
// EXTERNAL MODULE: ./src/components/TransakModal.tsx + 5 modules
var TransakModal = __webpack_require__(41116);
// EXTERNAL MODULE: ./src/components/Wallet/WithWallet.tsx + 3 modules
var WithWallet = __webpack_require__(23188);
// EXTERNAL MODULE: ./src/config/externalLinks.ts
var externalLinks = __webpack_require__(1797);
// EXTERNAL MODULE: ./src/overrides/next/link.tsx
var next_link = __webpack_require__(27009);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(21519);
// EXTERNAL MODULE: ./src/utils/getBgImageProps.ts
var getBgImageProps = __webpack_require__(30799);
// EXTERNAL MODULE: ../node_modules/.pnpm/numbro@2.3.6/node_modules/numbro/dist/numbro.min.js
var numbro_min = __webpack_require__(69248);
var numbro_min_default = /*#__PURE__*/__webpack_require__.n(numbro_min);
// EXTERNAL MODULE: ./src/hooks/useStakeViewData.ts + 1 modules
var useStakeViewData = __webpack_require__(24872);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45813);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+modal@2.2.1_@chakra-ui+system@2.2.12_@types+react@18.0.21_framer-motion@7.4.0_react-dom@18.2.0_react@18.2.0/node_modules/@chakra-ui/modal/dist/index.esm.js + 58 modules
var modal_dist_index_esm = __webpack_require__(96950);
// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(51933);
// EXTERNAL MODULE: ./src/components/ModalOrDrawer/index.ts
var ModalOrDrawer = __webpack_require__(64881);
// EXTERNAL MODULE: ./src/components/TransactionDrawer/index.tsx + 5 modules
var TransactionDrawer = __webpack_require__(42945);
// EXTERNAL MODULE: ./src/hooks/useStakeCoin.ts
var useStakeCoin = __webpack_require__(42203);
// EXTERNAL MODULE: ./src/providers/VenoSDKProvider.tsx
var VenoSDKProvider = __webpack_require__(29142);
// EXTERNAL MODULE: ./src/views/Stake/util.ts
var util = __webpack_require__(12127);
;// CONCATENATED MODULE: ./src/views/Stake/StakeCroDrawer.tsx



















var StakeCroView;
(function(StakeCroView) {
    StakeCroView[StakeCroView["CONFIRM"] = 0] = "CONFIRM";
    StakeCroView[StakeCroView["PENDING"] = 1] = "PENDING";
    StakeCroView[StakeCroView["ERROR"] = 2] = "ERROR";
    StakeCroView[StakeCroView["COMPLETE"] = 3] = "COMPLETE";
})(StakeCroView || (StakeCroView = {}));
var StakeCroDrawer = function(param) {
    var coinMode = param.coinMode, isDrawerOpen = param.isDrawerOpen, onCloseDrawer = param.onCloseDrawer, amountToStake = param.amountToStake, apyList = param.apyList, balance = param.balance, balanceUsd = param.balanceUsd, croPerStcro = param.croPerStcro, account = param.account, oneYearUsdRewards = param.oneYearUsdRewards;
    var t = (0,i18n/* useTranslations */.T_)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[coinMode];
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var ref = (0,useStakeCoin/* default */.Z)(), stakeCoin = ref.mutateAsync;
    var ref1 = (0,react.useState)(""), errorCode = ref1[0], setErrorCode = ref1[1];
    var ref2 = (0,react.useState)(""), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(false), transactionPending = ref3[0], setTransactionPending = ref3[1];
    var ref4 = (0,react.useState)(null), receivedLCoin = ref4[0], setReceivedLCoin = ref4[1];
    var ref5 = (0,react.useState)(1), nSteps = ref5[0], setNSteps = ref5[1];
    var ref6 = (0,react.useState)(1), currentStep = ref6[0], setCurrentStep = ref6[1];
    var numberToStake = (0,react.useMemo)(function() {
        return parseFloat(amountToStake);
    }, [
        amountToStake
    ]);
    var currentView = (0,react.useMemo)(function() {
        if (errorCode) {
            return StakeCroView.ERROR;
        }
        if (transactionPending) {
            return StakeCroView.PENDING;
        }
        if (receivedLCoin) {
            return StakeCroView.COMPLETE;
        }
        return StakeCroView.CONFIRM;
    }, [
        errorCode,
        receivedLCoin,
        transactionPending
    ]);
    var doStake = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var amount, p, err, errorCode;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        setTransactionPending(true);
                        setErrorCode("");
                        setErrorMessage("");
                        amount = (0,lib_esm.parseUnits)(amountToStake, coinModeInfo.decimals);
                        return [
                            4,
                            (0,util/* doApprovals */.O)(sdk, account, amount, setNSteps, setCurrentStep, coinMode)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            stakeCoin({
                                receiver: account !== null && account !== void 0 ? account : "",
                                amount: amount
                            })
                        ];
                    case 2:
                        p = _state.sent();
                        setTransactionPending(false);
                        setReceivedLCoin((0,util/* getReceivedCoin */.U)(p, coinMode, sdk));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error(err);
                        setTransactionPending(false);
                        errorCode = err.code;
                        if (err.message) {
                            setErrorMessage(err.message);
                        }
                        setErrorCode(errorCode);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function doStake() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeAndReset = function() {
        onCloseDrawer();
        setErrorCode("");
        setTransactionPending(false);
        setReceivedLCoin(null);
        setErrorMessage("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawer */.NH, {
        isOpen: isDrawerOpen,
        onClose: closeAndReset,
        scrollBehavior: "inside",
        placement: "bottom",
        size: {
            base: "full",
            desktop: "md"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerOverlay */.Dx, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDragDrawerContent */.Zt, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerHeader */.BB, {
                        children: t("Stake {coin}", {
                            coin: coinModeInfo.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InDesktop */.Fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* DrawerCloseButton */.cC, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerBodyWithMask */.tN, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeCroContent, {
                            coinMode: coinMode,
                            currentView: currentView,
                            receivedLCoin: receivedLCoin,
                            amountToStake: amountToStake,
                            apyList: apyList,
                            balance: balance,
                            balanceUsd: balanceUsd,
                            croPerStcro: croPerStcro,
                            errorCode: errorCode,
                            errorMessage: errorMessage,
                            numberToStake: numberToStake,
                            oneYearUsdRewards: oneYearUsdRewards,
                            nSteps: nSteps,
                            currentStep: currentStep
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerFooter */.Un, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeCroFooter, {
                            coinMode: coinMode,
                            currentView: currentView,
                            closeAndReset: closeAndReset,
                            doStake: doStake,
                            transactionPending: transactionPending
                        })
                    })
                ]
            })
        ]
    });
};
var StakeCroContent = function(param) {
    var coinMode = param.coinMode, currentView = param.currentView, receivedLCoin = param.receivedLCoin, errorCode = param.errorCode, errorMessage = param.errorMessage, balance = param.balance, balanceUsd = param.balanceUsd, amountToStake = param.amountToStake, numberToStake = param.numberToStake, croPerStcro = param.croPerStcro, apyList = param.apyList, oneYearUsdRewards = param.oneYearUsdRewards, nSteps = param.nSteps, currentStep = param.currentStep;
    var t = (0,i18n/* useTranslations */.T_)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[coinMode];
    var ref = (0,useCoinUsdValue/* useCoinUsdValue */.x)(numberToStake, coinMode), numberToStakeUsd = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentView === StakeCroView.COMPLETE && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* StakeTransactionCompleted.Content */.VT.Content, {
                coinMode: coinMode,
                receivedAmount: receivedLCoin
            }),
            currentView === StakeCroView.PENDING && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* TransactionPending.Content */.$$.Content, {
                nSteps: nSteps,
                currentStep: currentStep
            }),
            currentView === StakeCroView.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* TransactionError.Content */.qw.Content, {
                errorCode: errorCode,
                errorMessage: errorMessage
            }),
            currentView === StakeCroView.CONFIRM && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                minH: "full",
                flexDir: "column",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        title: t("Amount to stake"),
                        amount: numberToStake,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(coinModeInfo.Icon, {}),
                        usdAmount: numberToStakeUsd,
                        usdDisplayDecimals: 0,
                        showUsdAmount: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                        title: t("You will receive"),
                        value: !amountToStake || isNaN(numberToStake) || numberToStake <= 0 ? "0" : croPerStcro ? "".concat((0,format/* formatNumber */.uf)(Math.floor(100 * numberToStake / croPerStcro) / 100, 2), " ").concat(coinModeInfo.liquidName) : undefined,
                        mt: "20px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                        title: t("Exchange rate"),
                        value: croPerStcro ? "1 ".concat(coinModeInfo.liquidName, " = ").concat(croPerStcro.toFixed(4), " ").concat(coinModeInfo.name) : undefined
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                        title: t("Estimated rewards"),
                        convertedValue: !isNaN(oneYearUsdRewards !== null && oneYearUsdRewards !== void 0 ? oneYearUsdRewards : 0) ? "".concat((0,format/* formatNumber */.uf)(oneYearUsdRewards !== null && oneYearUsdRewards !== void 0 ? oneYearUsdRewards : 0, 2), " USD") : undefined,
                        value: apyList.length < 3 || !Number(amountToStake) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                    as: "span",
                                    whiteSpace: "nowrap",
                                    children: [
                                        "0.00 ",
                                        coinModeInfo.name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                    as: "span",
                                    whiteSpace: "nowrap",
                                    children: [
                                        " ",
                                        t("in 1 year")
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                    as: "span",
                                    whiteSpace: "nowrap",
                                    children: [
                                        (Number(amountToStake) * apyList[2]).toFixed(2),
                                        " ",
                                        coinModeInfo.name
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                    as: "span",
                                    whiteSpace: "nowrap",
                                    children: [
                                        " ",
                                        t("in 1 year")
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthlyRewardChart, {
                        coinMode: coinMode,
                        my: {
                            desktop: 1
                        },
                        amount: numberToStake,
                        smallChart: true
                    })
                ]
            })
        ]
    });
};
var StakeCroFooter = function(param) {
    var coinMode = param.coinMode, currentView = param.currentView, closeAndReset = param.closeAndReset, transactionPending = param.transactionPending, doStake = param.doStake;
    var t = (0,i18n/* useTranslations */.T_)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentView === StakeCroView.COMPLETE && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* StakeTransactionCompleted.Footer */.VT.Footer, {
                coinMode: coinMode,
                onCloseDrawer: closeAndReset
            }),
            currentView === StakeCroView.PENDING && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionDrawer/* TransactionPending.Footer */.$$.Footer, {}),
            currentView === StakeCroView.CONFIRM && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                onClick: doStake,
                isLoading: transactionPending,
                children: t("Confirm Staking")
            })
        ]
    });
};
/* harmony default export */ var Stake_StakeCroDrawer = (StakeCroDrawer);

;// CONCATENATED MODULE: ./src/views/Stake/index.tsx

























var StakeView = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[globalCoinMode];
    var ref = (0,react.useState)(false), isDisplayTotalExact = ref[0], setIsDisplayTotalExact = ref[1];
    var ref1 = (0,useStakeViewData/* default */.Z)(), isConnected = ref1.isConnected, apy = ref1.apy, apyLoading = ref1.apyLoading, account = ref1.account, apyList = ref1.apyList, balance = ref1.balance, balanceUsd = ref1.balanceUsd, croPerStcro = ref1.croPerStcro, grossApy = ref1.grossApy, maxStakeAmount = ref1.maxStakeAmount;
    var isDesktop = (0,index_esm/* useBreakpointValue */.Sx)({
        base: false,
        desktop: true
    });
    var maxDecimalsAllowed = Math.min(coinModeInfo.decimals, 8);
    var ref2 = (0,react.useState)(false), stakingInfoDrawerOpen = ref2[0], setStakingInfoDrawerOpen = ref2[1];
    var ref3 = (0,react.useState)(""), amountToStake = ref3[0], setAmountToStake = ref3[1];
    (0,react.useEffect)(function() {
        setAmountToStake("");
        setInputError("");
    }, [
        globalCoinMode
    ]);
    var ref4 = useOneYearUsdRewards(apyList, parseFloat(amountToStake !== null && amountToStake !== void 0 ? amountToStake : 0)), oneYearUsdRewards = ref4.data;
    var ref5 = (0,useCoinUsdValue/* useCoinUsdValue */.x)(parseFloat(amountToStake !== null && amountToStake !== void 0 ? amountToStake : 0)), dollarToStake = ref5.data;
    var ref6 = (0,react.useState)(false), drawerOpen = ref6[0], setDrawerOpen = ref6[1];
    var ref7 = (0,react.useState)(""), inputError = ref7[0], setInputError = ref7[1];
    var numberToStake = (0,react.useMemo)(function() {
        return parseFloat(amountToStake);
    }, [
        amountToStake
    ]);
    var bgImageProps = globalCoinMode === "atom" ? (0,getBgImageProps/* default */.Z)("PATTERN_1_ATOM") : (0,getBgImageProps/* default */.Z)("PATTERN_2");
    var openTransakModal = (0,TransakModal/* useTransakModal */.S)(function(s) {
        return s.onOpen;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInMobile */.ub, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StakingInfoDrawer/* default */.Z, {
                    netApy: "".concat((apy * 100).toFixed(2), "%"),
                    grossApy: "".concat(((grossApy !== null && grossApy !== void 0 ? grossApy : 0) * 100).toFixed(2), "%"),
                    isOpen: stakingInfoDrawerOpen,
                    close: function() {
                        return setStakingInfoDrawerOpen(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WithWallet/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mt: "32px",
                mb: "24px",
                px: "16px",
                connectHint: t("Connect your wallet to stake {coin}", {
                    coin: coinModeInfo.name
                }),
                bgPos: "right -36px top -50px",
                minH: "572px"
            }, bgImageProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stake_StakeCroDrawer, {
                        coinMode: globalCoinMode,
                        isDrawerOpen: drawerOpen,
                        onCloseDrawer: function() {
                            setDrawerOpen(false);
                            setAmountToStake("");
                        },
                        amountToStake: amountToStake,
                        apyList: apyList,
                        balance: balance !== null && balance !== void 0 ? balance : 0,
                        balanceUsd: balanceUsd !== null && balanceUsd !== void 0 ? balanceUsd : 0,
                        croPerStcro: croPerStcro !== null && croPerStcro !== void 0 ? croPerStcro : 1,
                        account: account !== null && account !== void 0 ? account : "",
                        oneYearUsdRewards: oneYearUsdRewards
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        title: t("Wallet {coin} Balance", {
                            coin: coinModeInfo.name
                        }),
                        amount: balance,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(coinModeInfo.Icon, {}),
                        usdAmount: balanceUsd,
                        usdDisplayDecimals: 2,
                        showUsdAmount: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                        mt: "4px",
                        mb: "36px",
                        justify: "center",
                        children: globalCoinMode === "atom" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            as: "a",
                            variant: "link",
                            color: "text-link",
                            href: externalLinks/* EXTERNAL_LINK.vvsSwapCroToAtom */.A.vvsSwapCroToAtom,
                            target: "_blank",
                            children: t("Buy {coin}", {
                                coin: "ATOM"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "link",
                            color: "text-link",
                            onClick: function() {
                                openTransakModal({
                                    entryPoint: "Stake"
                                });
                            },
                            children: t("Buy {coin}", {
                                coin: "CRO"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                        as: "main",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                infoButtonAction: function() {
                                    return !isDesktop && setStakingInfoDrawerOpen(true);
                                },
                                tooltip: apy && grossApy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApyInfo/* default */.Z, {
                                    netApy: "".concat((apy * 100).toFixed(2), "%"),
                                    grossApy: "".concat((grossApy * 100).toFixed(2), "%")
                                }) : undefined,
                                tooltipProps: {
                                    minW: {
                                        base: "full",
                                        desktop: "407px"
                                    }
                                },
                                title: t("Real Staking APY"),
                                value: !apyLoading ? apy === 0 ? "--" : "".concat((apy * 100).toFixed(2), "%") : undefined
                            }),
                            !isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                width: "full",
                                alignItems: "center",
                                children: [
                                    "Please ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                        href: "/",
                                        children: "connect your wallet"
                                    }),
                                    " first."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                justify: "flex-start",
                                flexDir: "column",
                                gap: 4,
                                mt: "12px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard/* InputCard */.K, {
                                        label: t("Input {coin} amount", {
                                            coin: coinModeInfo.name
                                        }),
                                        max: maxStakeAmount ? maxStakeAmount : undefined,
                                        warningMessage: amountToStake === String(maxStakeAmount) && coinModeInfo.coinMode === "cro" ? t("Gas fee has been deducted from maximum balance") : undefined,
                                        errorMessage: inputError,
                                        value: amountToStake,
                                        maxDecimals: maxDecimalsAllowed,
                                        usdValue: dollarToStake,
                                        onChange: function(value) {
                                            // maximum of 8 decimals are allowed by the smart contract
                                            if (value && !new RegExp("^[0-9]+\\.?[0-9]{0,".concat(maxDecimalsAllowed, "}$")).test(value)) {
                                                if (new RegExp("\\.?[0-9]{".concat(maxDecimalsAllowed + 1, ",}$")).test(value)) {
                                                    setInputError(t("maximum {decimal} decimal places allowed", {
                                                        decimal: maxDecimalsAllowed
                                                    }));
                                                } else {
                                                    setInputError(t("invalid format"));
                                                }
                                            } else if (parseFloat(value) < coinModeInfo.minStakeAmount) {
                                                setInputError(t("Below minimum limit {minAmount} {coin}", {
                                                    minAmount: coinModeInfo.minStakeAmount,
                                                    coin: coinModeInfo.name
                                                }));
                                            } else if (parseFloat(value) > (balance !== null && balance !== void 0 ? balance : 0)) {
                                                setInputError(t("{coin} balance too low", {
                                                    coin: coinModeInfo.name
                                                }));
                                            } else {
                                                setInputError("");
                                            }
                                            setAmountToStake(value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        mt: 1,
                                        mb: 2,
                                        onClick: function() {
                                            return setDrawerOpen(true);
                                        },
                                        disabled: !!inputError || !amountToStake,
                                        w: {
                                            desktop: constants/* MAXW_DESKTOP_CTA */.D3
                                        },
                                        mx: {
                                            desktop: "auto"
                                        },
                                        children: t("Stake")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                    children: t("You will receive")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    display: "block",
                                                    variant: "link",
                                                    onClick: function() {
                                                        return setIsDisplayTotalExact(function(v) {
                                                            return !v;
                                                        });
                                                    },
                                                    children: t("Show exact")
                                                })
                                            ]
                                        }),
                                        value: !amountToStake || isNaN(numberToStake) || numberToStake <= 0 ? "0 ".concat(coinModeInfo.liquidName) : croPerStcro ? isDisplayTotalExact ? "".concat(numbro_min_default()(numberToStake / croPerStcro).format({
                                            thousandSeparated: true,
                                            mantissa: coinModeInfo.liquidDecimals,
                                            trimMantissa: true
                                        }), " ").concat(coinModeInfo.liquidName) : "".concat(numbro_min_default()(Math.floor(100 * numberToStake / croPerStcro) / 100).format({
                                            thousandSeparated: true,
                                            mantissa: 2
                                        }), " ").concat(coinModeInfo.liquidName) : undefined,
                                        mt: "4px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                        title: t("Exchange rate"),
                                        value: croPerStcro ? "1 ".concat(coinModeInfo.liquidName, " = ").concat(croPerStcro.toFixed(4), " ").concat(coinModeInfo.name) : undefined
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                        title: t("Estimated rewards"),
                                        convertedValue: // don't show if there's an input error, else value will shown as 0 and conv. value > 0
                                        !isNaN(oneYearUsdRewards !== null && oneYearUsdRewards !== void 0 ? oneYearUsdRewards : 0) && !inputError ? "".concat((0,format/* formatNumber */.uf)(oneYearUsdRewards !== null && oneYearUsdRewards !== void 0 ? oneYearUsdRewards : 0, 2), " USD") : undefined,
                                        value: apyList.length < 3 || !Number(amountToStake) || inputError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                    as: "span",
                                                    whiteSpace: "nowrap",
                                                    children: [
                                                        "0.00 ",
                                                        coinModeInfo.name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                    as: "span",
                                                    whiteSpace: "nowrap",
                                                    children: [
                                                        " ",
                                                        t("in 1 year")
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                    as: "span",
                                                    whiteSpace: "nowrap",
                                                    children: [
                                                        (Number(amountToStake) * apyList[2]).toFixed(2),
                                                        " ",
                                                        coinModeInfo.name
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                    as: "span",
                                                    whiteSpace: "nowrap",
                                                    children: [
                                                        " ",
                                                        t("in 1 year")
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthlyRewardChart, {
                                        coinMode: globalCoinMode,
                                        amount: Number(amountToStake),
                                        warningMessage: !Number(amountToStake) ? t("Input {coin} amount above to see estimated rewards", {
                                            coin: coinModeInfo.name
                                        }) : undefined,
                                        errorMessage: inputError ? t("Estimated rewards isn’t available at the moment") : undefined
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }))
        ]
    });
};
var useOneYearUsdRewards = function(apyList, amount) {
    var oneYearCroRewards = apyList.length > 2 ? apyList[2] * amount : 0;
    return (0,useCoinUsdValue/* useCoinUsdValue */.x)(oneYearCroRewards);
};


/***/ }),

/***/ 92699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ StakeAndUseLcroDesktop; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 1 modules
var Card = __webpack_require__(99726);
// EXTERNAL MODULE: ./src/components/DesktopBg.tsx
var DesktopBg = __webpack_require__(77474);
// EXTERNAL MODULE: ./src/components/HowItWorksDrawer/index.tsx
var HowItWorksDrawer = __webpack_require__(84030);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ./src/hooks/router.ts + 2 modules
var router = __webpack_require__(81554);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ./src/hooks/useIsFeatureEnabled.ts
var useIsFeatureEnabled = __webpack_require__(79623);
// EXTERNAL MODULE: ./src/components/Features.tsx
var Features = __webpack_require__(18232);
;// CONCATENATED MODULE: ./src/components/StakeModeSwitchTab.tsx










var isStrategyEnabled = (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.strategyVault */.R.strategyVault);
var items = isStrategyEnabled ? [
    {
        coin: useCoinMode/* COIN_MODE.cro.coinMode */.rm.cro.coinMode,
        isStrategy: false
    },
    {
        coin: useCoinMode/* COIN_MODE.atom.coinMode */.rm.atom.coinMode,
        isStrategy: false
    },
    {
        coin: useCoinMode/* COIN_MODE.cro.coinMode */.rm.cro.coinMode,
        isStrategy: true
    }, 
] : [
    {
        coin: useCoinMode/* COIN_MODE.cro.coinMode */.rm.cro.coinMode,
        isStrategy: false
    },
    {
        coin: useCoinMode/* COIN_MODE.atom.coinMode */.rm.atom.coinMode,
        isStrategy: false
    }, 
];
var StakeModeSwitchTab = function(_param) {
    var _mode = _param.mode, onCoinModeChange = _param.onModeChange, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "mode",
        "onModeChange",
        "children"
    ]);
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var realPathName = (0,router/* useRealPathname */.ZD)();
    var pathInfo = (0,router/* getPathInfo */.o$)(realPathName);
    var mode = _mode !== null && _mode !== void 0 ? _mode : {
        coin: globalCoinMode,
        isStrategy: pathInfo.category === "strategy"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        gap: "4px",
        w: "188px",
        flexShrink: "0"
    }, props), {
        children: items.map(function(item, i) {
            var isActive = item.coin === mode.coin && item.isStrategy === mode.isStrategy;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                whiteSpace: "nowrap",
                variant: "button",
                isActive: isActive,
                cursor: "pointer",
                textStyle: "h4Bold",
                color: isActive ? "text-active" : "text-inactive",
                p: "10px",
                textAlign: "center",
                justifyContent: "center",
                onClick: function() {
                    onCoinModeChange(item.coin, item.isStrategy);
                },
                children: children(item.coin, item.isStrategy)
            }, i);
        })
    }));
};

// EXTERNAL MODULE: ./src/components/Wallet/WithWallet.tsx + 3 modules
var WithWallet = __webpack_require__(23188);
// EXTERNAL MODULE: ./src/config/paths.ts
var paths = __webpack_require__(71953);
// EXTERNAL MODULE: ./src/hooks/useShowHowItWorks.ts
var useShowHowItWorks = __webpack_require__(45971);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/overrides/next/router.ts
var next_router = __webpack_require__(95849);
// EXTERNAL MODULE: ./src/views/Stake/index.tsx + 3 modules
var Stake = __webpack_require__(10952);
// EXTERNAL MODULE: ./src/views/Strategy/DepositAndWithdraw.tsx + 5 modules
var DepositAndWithdraw = __webpack_require__(21101);
// EXTERNAL MODULE: ./src/views/UseLcroDirectly/index.tsx + 6 modules
var UseLcroDirectly = __webpack_require__(95595);
// EXTERNAL MODULE: ./src/views/StakeAndUseLcro/howItWorks.tsx
var howItWorks = __webpack_require__(34961);
;// CONCATENATED MODULE: ./src/views/StakeAndUseLcro/StakeAndUseLcroDesktop.tsx


















var StakeAndUseLcroDesktop = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[globalCoinMode];
    var realPathName = (0,router/* useRealPathname */.ZD)();
    var pathInfo = (0,router/* getPathInfo */.o$)(realPathName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopBg/* default */.ZP, {
                pattern: globalCoinMode === "atom" ? "PATTERN_3_ATOM" : "PATTERN_3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksDrawer/* default */.Z, (0,_object_spread/* default */.Z)({
                hintType: useShowHowItWorks/* HintType.STAKE */.T.STAKE
            }, (0,howItWorks/* useStakeHint */.G)())),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WithWallet/* default */.Z, {
                mt: "7px",
                connectHint: t("Connect wallet to see dashboard"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    flexDir: "column",
                    gap: "19px",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        gap: 1,
                        w: "full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeModeSwitchTab, {
                                mr: "10px",
                                onModeChange: function(coinMode, isStrategy) {
                                    next_router/* default.push */.ZP.push(isStrategy ? paths/* pathDict */.o$[coinMode].strategy.deposit : paths/* pathDict */.o$[coinMode].stake);
                                },
                                children: function(coinMode, isStrategy) {
                                    return isStrategy ? t("Liquidity Strategy") : t("Stake {coin}", {
                                        coin: useCoinMode/* COIN_MODE */.rm[coinMode].name
                                    });
                                }
                            }),
                            pathInfo.category !== "strategy" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
                                        flexGrow: "1",
                                        width: 0,
                                        px: 6,
                                        pt: 4,
                                        mx: 0,
                                        mr: "10px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                textStyle: "h3",
                                                children: t("Stake {coin}", {
                                                    coin: coinModeInfo.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stake/* StakeView */.V, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
                                        flexGrow: "1",
                                        width: 0,
                                        px: 6,
                                        pt: 4,
                                        mx: 0,
                                        ml: "10px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                textStyle: "h3",
                                                children: t("Use {coin}", {
                                                    coin: coinModeInfo.liquidName
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly/* default */.Z, {})
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                    w: "480px",
                                    ml: "200px",
                                    px: 6,
                                    pt: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositAndWithdraw/* DepositAndWithdraw */.X, {})
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 34961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useStakeHint; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66697);
/* harmony import */ var _ui_components_AddTokenButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7934);
/* harmony import */ var _ui_hooks_useCoinMode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93397);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68866);





var useStakeHint = function() {
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslations */ .T_)();
    var globalCoinMode = (0,_ui_hooks_useCoinMode__WEBPACK_IMPORTED_MODULE_2__/* .useCoinMode */ .mc)();
    if (globalCoinMode === "atom") {
        return {
            title: t("Stake ATOM & use LATOM"),
            longText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    t("stake-atom-how-it-works-desc-{br}", {
                        br: function() {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_AddTokenButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        mb: "20px",
                        tokenType: _ui_components_AddTokenButton__WEBPACK_IMPORTED_MODULE_1__/* .TokenType.LATOM */ .i.LATOM,
                        text: t("Add {coin} to wallet", {
                            coin: "LATOM"
                        })
                    })
                ]
            }),
            shortText: t("stake-atom-how-it-works-desc-{br}", {
                br: function() {
                    return "";
                }
            }).slice(0, 69) + "...",
            shortTextDesktop: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        color: "black",
                        fontWeight: "bold",
                        display: "inline",
                        children: [
                            t("Stake"),
                            ":",
                            " "
                        ]
                    }),
                    t("stake-atom-how-it-works-desc-{br}", {
                        br: function() {
                            return "";
                        }
                    }).slice(0, 122),
                    "..."
                ]
            })
        };
    }
    return {
        title: t("Stake CRO & use LCRO"),
        longText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                t("stake-cro-how-it-works-desc-{br}", {
                    br: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_AddTokenButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    mb: "20px",
                    tokenType: _ui_components_AddTokenButton__WEBPACK_IMPORTED_MODULE_1__/* .TokenType.LCRO */ .i.LCRO,
                    text: t("Add {coin} to wallet", {
                        coin: "LCRO"
                    })
                })
            ]
        }),
        shortText: t("stake-cro-how-it-works-desc-{br}", {
            br: function() {
                return "";
            }
        }).slice(0, 71) + "...",
        shortTextDesktop: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                    color: "black",
                    fontWeight: "bold",
                    display: "inline",
                    children: [
                        t("Stake"),
                        ":",
                        " "
                    ]
                }),
                t("stake-cro-how-it-works-desc-{br}", {
                    br: function() {
                        return "";
                    }
                }).slice(0, 121),
                "..."
            ]
        })
    };
};


/***/ }),

/***/ 95595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ views_UseLcroDirectly; }
});

// UNUSED EXPORTS: UseLcroDirectlyPartnerCards

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ./src/components/Balance/index.ts
var Balance = __webpack_require__(64345);
// EXTERNAL MODULE: ./src/components/Features.tsx
var Features = __webpack_require__(18232);
// EXTERNAL MODULE: ./src/components/MobileAppBarProvider/index.tsx + 4 modules
var MobileAppBarProvider = __webpack_require__(19391);
// EXTERNAL MODULE: ./src/components/Wallet/WithWallet.tsx + 3 modules
var WithWallet = __webpack_require__(23188);
// EXTERNAL MODULE: ./src/hooks/useCoinMode.tsx
var useCoinMode = __webpack_require__(93397);
// EXTERNAL MODULE: ./src/hooks/useIsFeatureEnabled.ts
var useIsFeatureEnabled = __webpack_require__(79623);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/utils/getBgImageProps.ts
var getBgImageProps = __webpack_require__(30799);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(67496);
// EXTERNAL MODULE: ./src/hooks/useCoinPerStakedCoin.ts
var useCoinPerStakedCoin = __webpack_require__(77700);
// EXTERNAL MODULE: ./src/hooks/useCoinUsdValue.ts
var useCoinUsdValue = __webpack_require__(33646);
// EXTERNAL MODULE: ./src/hooks/useLiquidCoinBalance.ts
var useLiquidCoinBalance = __webpack_require__(96164);
// EXTERNAL MODULE: ./src/overrides/next/router.ts
var router = __webpack_require__(95849);
// EXTERNAL MODULE: ./src/queries/queries.ts + 4 modules
var queries = __webpack_require__(54495);
// EXTERNAL MODULE: ./src/queries/queryKey.ts
var queryKey = __webpack_require__(51794);
// EXTERNAL MODULE: ./src/views/UseLcroDirectly/useSupplyLcroModalStore.ts
var useSupplyLcroModalStore = __webpack_require__(87578);
;// CONCATENATED MODULE: ./src/views/UseLcro/components/useUseLcro.ts










var useUseLcro = function() {
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var ref = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(), openModal = ref.open;
    var query = (0,router/* useRouter */.tv)().query;
    var deposit = query.deposit;
    (0,react.useEffect)(function() {
        if (deposit === "ferro") openModal({
            type: "FERRO",
            coinMode: globalCoinMode
        });
        else if (deposit === "vvs") openModal({
            type: "VVS",
            coinMode: globalCoinMode
        });
        else if (deposit === "tectonic") openModal({
            type: "TECTONIC",
            coinMode: globalCoinMode
        });
        else if (deposit === "vvs_cro") openModal({
            type: "VVS_CRO",
            coinMode: globalCoinMode
        });
    }, [
        deposit,
        globalCoinMode,
        openModal
    ]);
    var ref1 = (0,useLiquidCoinBalance/* useLiquidCoinBalance */.D)(), lcroBalance = ref1.data, lcroBalanceLoading = ref1.isLoading;
    var ref2 = (0,useCoinPerStakedCoin/* default */.Z)(), croPerStcro = ref2.data;
    var ref3 = (0,useCoinUsdValue/* useCoinUsdValue */.x)(croPerStcro ? lcroBalance === null || lcroBalance === void 0 ? void 0 : lcroBalance.mul(Math.round(croPerStcro * 1000000)).div(1000000) : undefined), lcroBalanceUsd = ref3.data, lcroBalanceUsdLoading = ref3.isLoading;
    var ferroApyQuery = (0,queries/* getQuery */.p)(queryKey/* QueryKey.FERRO_APY */.S.FERRO_APY)(globalCoinMode);
    var ref4 = (0,useQuery/* useQuery */.a)(ferroApyQuery.queryKey, ferroApyQuery.queryFn), ferroApy = ref4.data, ferroApyLoading = ref4.isLoading;
    return {
        lcroBalanceUsd: lcroBalanceUsd,
        lcroBalance: lcroBalance,
        lcroBalanceUsdLoading: lcroBalanceUsdLoading,
        lcroBalanceLoading: lcroBalanceLoading,
        ferroApy: ferroApy,
        ferroApyLoading: ferroApyLoading
    };
};
/* harmony default export */ var components_useUseLcro = (useUseLcro);

// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+button@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(31327);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 1 modules
var Card = __webpack_require__(99726);
// EXTERNAL MODULE: ./src/components/useYourTokenDrawer/index.tsx + 2 modules
var useYourTokenDrawer = __webpack_require__(4128);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45813);
// EXTERNAL MODULE: ./src/components/TokenIcon.tsx
var TokenIcon = __webpack_require__(47982);
// EXTERNAL MODULE: ./src/hooks/useGardenApy.ts
var useGardenApy = __webpack_require__(55814);
// EXTERNAL MODULE: ./src/hooks/usePartnerStats.ts
var usePartnerStats = __webpack_require__(82251);
// EXTERNAL MODULE: ./src/hooks/useSingleFinanceLcroFarmInfo.ts
var useSingleFinanceLcroFarmInfo = __webpack_require__(36527);
// EXTERNAL MODULE: ./src/queries/ferroTotalLockedValue.ts
var ferroTotalLockedValue = __webpack_require__(72882);
// EXTERNAL MODULE: ./src/utils/bigNumberToNumber.ts
var bigNumberToNumber = __webpack_require__(19089);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(25966);
// EXTERNAL MODULE: ./src/utils/garden.ts
var garden = __webpack_require__(98097);
;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/useLcroCard/utils.tsx
















var useLcroProtocols = function() {
    var ref, ref1, ref2, ref3;
    var t = (0,i18n/* useTranslations */.T_)();
    var tectonicTvlRet = (0,usePartnerStats/* useTectonicSupplyUsd */.j3)();
    var singleFinanceFarmTvlRet = (0,useSingleFinanceLcroFarmInfo/* useSingleFinanceLcroFarmInfo */.Q)();
    var singleFinanceLendTvlRet = useSingleFinanceLendInfo();
    // same as in useUseLcroPartnerCardsData
    var ref4 = (0,useGardenApy/* default */.Z)(undefined, true), ferroApy = ref4.ferroGardenApy, tectonicApy = ref4.tectonicGardenApy, vvsApy = ref4.vvsCroGardenApy;
    var ferroTvlRet = (0,useQuery/* useQuery */.a)((0,_object_spread/* default */.Z)({}, (0,ferroTotalLockedValue/* getFerroTotalLockedValue */.I)({
        coinMode: "cro"
    })));
    var lcroProtocols = [];
    var list = [
        {
            logo: "/images/use-ferro.png",
            title: "Ferro",
            subtitle: t("Provide Liquidity"),
            titleTail: ferroApy ? "".concat((0,garden/* formatGardenApy */.VV)(ferroApy)) : undefined,
            tvl: ferroTvlRet.data ? "$".concat((0,format/* formatNumber */.uf)(ferroTvlRet.data, 2)) : undefined,
            description: t("Provide liquidity for {liquidCoin} on Cronos' leading stable swap and earn additional rewards on your {liquidCoin} Earn even more with the {garden}", {
                liquidCoin: "LCRO",
                garden: (0,garden/* getGardenName */.gr)("cro", "FERRO")
            }),
            tokens: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                token: "lcro",
                w: "32px",
                h: "32px"
            }),
            url: "https://ferroprotocol.com/"
        },
        {
            logo: "/images/use-tectonic.png",
            title: "Tectonic",
            titleTail: tectonicApy ? "".concat((0,garden/* formatGardenApy */.VV)(tectonicApy)) : undefined,
            tvl: tectonicTvlRet.data ? "$".concat((0,format/* formatNumber */.uf)((0,bigNumberToNumber/* default */.Z)(tectonicTvlRet.data), 2)) : undefined,
            subtitle: t("Lend {coin}", {
                coin: "LCRO"
            }),
            description: t("Supply {liquidCoin} on the leading money market on Cronos and earn interest from borrowers Earn additional rewards with the {garden}", {
                liquidCoin: "LCRO",
                garden: (0,garden/* getGardenName */.gr)("cro", "TECTONIC")
            }),
            tokens: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                token: "lcro",
                w: "32px",
                h: "32px"
            }),
            url: "https://tectonic.finance/"
        },
        {
            logo: "/images/single-finance-logo.png",
            title: "Single Finance",
            subtitle: t("Leveraged Yield Farming"),
            description: t("Use {liquidCoin} for leveraged yield farming on Single Finance", {
                liquidCoin: "LCRO"
            }),
            tokens: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                token: "lcro",
                w: "32px",
                h: "32px"
            }),
            url: "https://app.singlefinance.io/farm",
            titleTail: ((ref = singleFinanceFarmTvlRet.data) === null || ref === void 0 ? void 0 : ref.apy) ? (0,format/* formatPercentage */.rl)(singleFinanceFarmTvlRet.data.apy) : undefined,
            tvl: ((ref1 = singleFinanceFarmTvlRet.data) === null || ref1 === void 0 ? void 0 : ref1.tvlInUSD) ? "$".concat((0,format/* formatNumber */.uf)(singleFinanceFarmTvlRet.data.tvlInUSD, 2)) : undefined
        },
        {
            logo: "/images/single-finance-logo.png",
            title: "Single Finance",
            subtitle: t("Lend {coin}", {
                coin: "LCRO"
            }),
            description: t("Supply {liquidCoin} to leveraged yield farmers and earn interest", {
                liquidCoin: "LCRO"
            }),
            tokens: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                token: "lcro",
                w: "32px",
                h: "32px"
            }),
            url: "https://app.singlefinance.io/lend",
            titleTail: ((ref2 = singleFinanceLendTvlRet.data) === null || ref2 === void 0 ? void 0 : ref2.apy) ? (0,format/* formatPercentage */.rl)(singleFinanceLendTvlRet.data.apy) : undefined,
            tvl: ((ref3 = singleFinanceLendTvlRet.data) === null || ref3 === void 0 ? void 0 : ref3.tvlInUSD) ? "$".concat((0,format/* formatNumber */.uf)(singleFinanceLendTvlRet.data.tvlInUSD, 2)) : undefined
        },
        {
            logo: "/images/use-vvs.png",
            title: "VVS Finance",
            titleTail: vvsApy ? "".concat((0,garden/* formatGardenApy */.VV)(vvsApy)) : undefined,
            tvl: undefined,
            subtitle: "Farm",
            description: t("Put your {liquidCoin} to work on VVS Finance to earn attractive yield farming rewards!", {
                liquidCoin: "LCRO"
            }),
            tokens: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                token: "lcro",
                w: "32px",
                h: "32px"
            }),
            url: "https://vvs.finance/"
        },
        (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.wowmaxxSupport */.R.wowmaxxSupport) ? {
            logo: "https://pbs.twimg.com/profile_images/1531319801246797826/t8TIp5pX_400x400.jpg",
            title: "Wowmaxx",
            subtitle: t("Trade {coin}", {
                coin: "LCRO"
            }),
            description: t("Trade large amounts of {liquidCoin} with optimized slippage", {
                liquidCoin: "LCRO"
            }),
            tokens: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenIcon/* TokenIcon */.T, {
                token: "lcro",
                w: "32px",
                h: "32px"
            }),
            /**
           * todo cover.lv not deployed, need to update url
           */ url: ""
        } : null, 
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item) {
                lcroProtocols.push(item);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return lcroProtocols;
};
var useSingleFinanceLendInfo = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,useQuery/* useQuery */.a)([
        "useSingleFinanceLendInfo"
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var fetchResponse, response, tokenInfo;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("https://api.singlefinance.io/api/info/vaults?chainid=25")
                    ];
                case 1:
                    fetchResponse = _state.sent();
                    return [
                        4,
                        fetchResponse.json()
                    ];
                case 2:
                    response = _state.sent();
                    tokenInfo = response.data.vaults.find(function(v) {
                        return v.name === "ibLCRO";
                    });
                    return [
                        2,
                        {
                            tvlInUSD: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.tvlInUSD,
                            apy: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.apy
                        }
                    ];
            }
        });
    }), (0,_object_spread/* default */.Z)({}, options));
};

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/useLcroCard/index.tsx









var UseLcroCard = function(props) {
    var t = (0,i18n/* useTranslations */.T_)();
    var lcroProtocols = useLcroProtocols();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "flex",
        minH: "74px",
        p: {
            base: "10px 10px 16px",
            desktop: "10px 16px 16px"
        },
        gap: "10px",
        mx: "0",
        justifyContent: "space-between",
        cursor: "pointer",
        bgImage: "url('/images/pattern-3.png')",
        bgSize: "cover",
        bgRepeat: "no-repeat",
        bgPos: "center -152px",
        onClick: function() {
            useYourTokenDrawer/* useUseYourTokenDrawer.getState */.I.getState().onOpen({
                title: t("Use your {coin}", {
                    coin: "LCRO"
                }),
                protocols: lcroProtocols
            });
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                children: t("View all projects & protocols {br} supporting LCRO", {
                    br: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                variant: "secondary",
                size: "sm",
                children: t("View")
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/hooks/useUseLcroPartnerCardsData.ts + 5 modules
var useUseLcroPartnerCardsData = __webpack_require__(11571);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+skeleton@2.0.17_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__(28440);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
// EXTERNAL MODULE: ./src/components/useYourTokenDrawer/DisclaimerDrawer.tsx
var DisclaimerDrawer = __webpack_require__(28939);
// EXTERNAL MODULE: ./src/config/paths.ts
var paths = __webpack_require__(71953);
// EXTERNAL MODULE: ./src/utils/urlHistory.ts
var urlHistory = __webpack_require__(59023);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.1_@babel+core@7.19.3_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(31508);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/UseLcroDirectlyPartnerCard.tsx












function UseLcroDirectlyPartnerCard(param) {
    var image = param.image, logo = param.logo, description = param.description, buttonText = param.buttonText, logoWidth = param.logoWidth, logoHeight = param.logoHeight, tvl = param.tvl, apy = param.apy, type = param.type, comingSoon = param.comingSoon;
    var t = (0,i18n/* useTranslations */.T_)();
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var isDesktop = (0,MobileOrDesktop/* useIsDesktop */.Ce)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[globalCoinMode];
    var ref = (0,useSupplyLcroModalStore/* useSupplyLcroModalStore */.b)(), openSupplyLcroModal = ref.open;
    var openDisclaimerDrawer = (0,DisclaimerDrawer/* useDisclaimerDrawer */.y0)(function(s) {
        return s.onOpen;
    });
    var clickCta = function() {
        if (type === "SINGLE") {
            isDesktop && useYourTokenDrawer/* useUseYourTokenDrawer.getState */.I.getState().onOpen({
                title: t("Use your {coin}", {
                    coin: "LCRO"
                }),
                protocols: []
            });
            openDisclaimerDrawer({
                url: "https://app.singlefinance.io/farm"
            });
            return;
        }
        openSupplyLcroModal({
            type: type,
            coinMode: globalCoinMode
        });
        (0,urlHistory/* replaceRouterWithoutRerender */.l)(paths/* pathDict */.o$[globalCoinMode].useLiquid + "/?deposit=".concat(type.toLowerCase()));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        flexDir: "column",
        py: 4,
        px: 2,
        gap: 4,
        boxShadow: "card.normal",
        bg: "bg.main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        flexShrink: "0",
                        bg: "bg.main",
                        shadow: "card.normal",
                        rounded: "full",
                        w: {
                            base: "70px",
                            desktop: "87px"
                        },
                        h: {
                            base: "70px",
                            desktop: "87px"
                        },
                        p: "4px",
                        justify: "stretch",
                        align: "stretch",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            position: "relative",
                            w: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "Brand image",
                                layout: "fill",
                                src: image
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        flexDir: "column",
                        justify: "flex-start",
                        align: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: logoWidth,
                                height: logoHeight !== null && logoHeight !== void 0 ? logoHeight : "20px",
                                alt: "Brand image",
                                src: logo
                            }),
                            !comingSoon && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    tvl !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                        gap: 1,
                                        mt: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                            minW: "90px",
                                            isLoaded: !!tvl,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                    as: "span",
                                                    textStyle: {
                                                        base: "bodySmall",
                                                        desktop: "body"
                                                    },
                                                    color: "text.light",
                                                    children: [
                                                        t("{coin} supplied", {
                                                            coin: coinModeInfo.liquidName
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                    as: "span",
                                                    textStyle: {
                                                        base: "bodySmallBold",
                                                        desktop: "bodyBold"
                                                    },
                                                    children: [
                                                        tvl,
                                                        " USD"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    apy !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                        minW: "70px",
                                        isLoaded: apy !== undefined,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                            mt: 1,
                                            textStyle: {
                                                base: "bodySmallBold",
                                                desktop: "h4Bold"
                                            },
                                            children: [
                                                apy,
                                                " APY"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            comingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                mt: "auto",
                                mb: 2,
                                textStyle: "bodyBold",
                                children: t("Coming soon!")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        flex: "1",
                        textAlign: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                            mr: 4,
                            color: "pink.500",
                            variant: "link",
                            alignSelf: "flex-start",
                            disabled: comingSoon,
                            onClick: clickCta,
                            children: comingSoon ? t("Stay Tuned") : t("Supply")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                textStyle: {
                    base: "bodySmall",
                    desktop: "body"
                },
                color: "text.light",
                children: description
            })
        ]
    });
}
/* harmony default export */ var UseLcroDirectly_UseLcroDirectlyPartnerCard = (UseLcroDirectlyPartnerCard);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/UseLcroDirectlyPartnerCards.tsx







function UseLcroDirectlyPartnerCards() {
    var coinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var partnerCardData = (0,useUseLcroPartnerCardsData/* useUseLcroPartnerCardsData */.H)(coinMode).partnerCardData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
            flexDir: "column",
            gap: 4,
            children: partnerCardData.map(function(data, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_UseLcroDirectlyPartnerCard, (0,_object_spread/* default */.Z)({}, data), i);
            })
        })
    });
}
/* harmony default export */ var UseLcroDirectly_UseLcroDirectlyPartnerCards = (UseLcroDirectlyPartnerCards);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/UseLcroDirectly.tsx
















function UseLcroDirectly(param) {
    var showTitle = param.showTitle;
    (0,MobileAppBarProvider/* useDefaultAppBar */.Xk)();
    var t = (0,i18n/* useTranslations */.T_)();
    var globalCoinMode = (0,useCoinMode/* useCoinMode */.mc)();
    var coinModeInfo = useCoinMode/* COIN_MODE */.rm[globalCoinMode];
    var bgImageProps = globalCoinMode === "atom" ? (0,getBgImageProps/* default */.Z)("PATTERN_2_ATOM") : (0,getBgImageProps/* default */.Z)("PATTERN_1");
    var ref = components_useUseLcro(), lcroBalanceUsd = ref.lcroBalanceUsd, lcroBalance = ref.lcroBalance;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            position: "relative",
            flexGrow: 1,
            bgPos: "left 90px"
        }, bgImageProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WithWallet/* default */.Z, {
                mt: 8,
                mb: "22px",
                px: "16px",
                connectHint: t("Connect wallet to see your {coin} balance", {
                    coin: coinModeInfo.liquidName
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        hidden: !showTitle || (0,useIsFeatureEnabled/* isFeatureEnabled */.cr)(Features/* features.Atom */.R.Atom),
                        textStyle: "h4Bold",
                        color: "text-active",
                        textAlign: "center",
                        children: t("Use {coin}", {
                            coin: coinModeInfo.liquidName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        mt: "24px",
                        title: t("Wallet {coin} Balance", {
                            coin: coinModeInfo.liquidName
                        }),
                        amount: lcroBalance,
                        unitDecimals: coinModeInfo.liquidDecimals,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(coinModeInfo.LiquidIcon, {}),
                        usdAmount: lcroBalanceUsd,
                        usdDisplayDecimals: 2,
                        showUsdAmount: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        mt: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroDirectly_UseLcroDirectlyPartnerCards, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* default.useLcroCard */.Z.useLcroCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseLcroCard, {
                            hidden: globalCoinMode !== "cro",
                            mt: "16px"
                        })
                    })
                ]
            })
        }))
    });
}
/* harmony default export */ var UseLcroDirectly_UseLcroDirectly = (UseLcroDirectly);

;// CONCATENATED MODULE: ./src/views/UseLcroDirectly/index.tsx


/* harmony default export */ var views_UseLcroDirectly = (UseLcroDirectly_UseLcroDirectly);


/***/ })

}]);